var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('i',{class:("fas fa-" + _vm.icon)}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }